import React from 'react';
import {Spin as AntdSpin} from 'antd'
import PropTypes from 'prop-types';
import Spinner from '../Spinner';

const Spin = ({
  size = 'medium',
  ...rest
}) => {

  return (
    <AntdSpin
      {...rest}
      indicator={<Spinner size={size} />}
      size={size}
    />
  );
}

Spin.propTypes = {
  size: PropTypes.oneOf(['xxsmall', 'xsmall', 'small', 'medium', 'large'])
};

export default Spin;
